module.exports = __webpack_public_path__ + "assets/6237534486c6378925e7f437ccbbdd03.mp3";